<template>
    <div>
        <div class="flex-y-center px-16" style="box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15); background: #191919">
            <!-- <div class="cursor-pointer ml-40" @click="$router.push({ name: 'homePage' })"><img style="height: 34px" class="pr-32" src="../../assets/image/logo1.png" alt="" /> -->
            <!-- <div @click="$router.push({ name: 'homePage' })" class="cursor-pointer"> -->
            <div  class="cursor-pointer">
                <!-- <img style="height: 34px" class="pr-32" src="../../assets/image/logo1.png" alt=""> -->
                <img style="height: 34px;width:190px" src="../../assets/image/baise.png" alt="">
                <!-- <el-dropdown @command="toOtherSystem">
                <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right selfIcon"></i>
                </span>
                <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item  v-for="(item,index) in otherMenu" :key="index" :command="item.url">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
             </el-dropdown> -->
            </div>
            <div class="flex-y-center flex-1">
                <i :style="{ visibility: moveNumber === 0 ? 'hidden' : '', fontWeight: '700' }" @click="move('left')" class="el-icon-arrow-left font-20 cursor-pointer" style="display: none" />
                <!-- <div style="width: 916px; overflow: hidden"> -->
                <div>
                    <el-menu
                        :default-active="activeIndex"
                        @select="changeMenu"
                        :style="menuStyle"
                        mode="horizontal"
                        class="d-flex"
                        background-color="#191919"
                        text-color="#FFFFFF"
                        active-text-color="#459E3F"
                    >
                        <!-- <el-menu
                        :default-active="$route.path"
                        mode="horizontal"
                        class="d-flex"
                        background-color="#191919"
                        text-color="#FFFFFF"
                        active-text-color="#459E3F"
                        @select="changeMenu"
                        :style="menuStyle"
                        router
                    > -->

                        <template v-for="(item, index) in menuData" class="d-flex">
                            <el-menu-item v-if="!item.children" :index="item.code" :key="index" class="flex-center">
                                <i :class="item.icon" />{{ item.name }}
                            </el-menu-item>
                            <el-submenu v-else :index="item.code" :key="index">
                                <template slot="title">
                                    <i :class="item.icon" />{{ item.name }}
                                </template>
                                <d-submenu v-for="(items, indexs) in item.children" :key="'father' + indexs" :menu="items" />
                            </el-submenu>
                        </template>
                    </el-menu>
                </div>
                <i
                    :style="{ visibility: moveNumber === menuData.length - 8 ? 'hidden' : '', fontWeight: '700' }"
                    @click="move('right')"
                    class="el-icon-arrow-right py-10 font-20 cursor-pointer font-weight-bold"
                />
            </div>
            <div class="flex-y-center float-right">
                <!-- <el-popover placement="bottom-end" width="248" trigger="click" class="qwes">
                    <message-pop @son-clear2='sonClear2' @son-clear1='sonClear1'  :badgeLength="badgeLength1" style="margin-top:10px"  :notice="notice" :doThing="doThing"></message-pop>
                    <el-badge :value="badgeLength1" :max="99" slot="reference">
                        <i class="el-icon-bell color-white text-20"></i>
                    </el-badge>
                </el-popover> -->
                <el-dropdown @command="dropDownCommand" class="">
                    <span class="el-dropdown-link flex-center">
                        <!-- <img :src="src" style="width: 32px; height: 32px" class="radius-50 mr-4" alt=""> 获取不到头像，注释掉-->
                        <span style="color: #fff">
                            {{ name }}
                        </span><i style="color: #fff" class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="center">
                            个人中心
                        </el-dropdown-item>
                        <el-dropdown-item command="changePass">
                            修改密码
                        </el-dropdown-item>
                        <el-dropdown-item command="out">
                            退出登陆
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-show="$route.meta.title" class="border-top-0 flex-x-center bg-default" style="height: 38px">
            <div class="flex-x-center flex-column" style="width: 96%">
                <!-- <div class="flex-x-center flex-column" style="margin-left:2%;"> -->
                <d-breadcrumb :data="breadcrumbData" />
                <!-- <div class="mt-8">{{ $route.meta.title }}</div> -->
            </div>
        </div>
        <div
            :style="{
                top: $route.meta.title ? '100px' : '77px',
                width: !$route.meta.title ? '100%' : '96%',
                'margin-left': !$route.meta.title ? '0' : '2%'
            }"
            class="absolute-all overflow-auto"
            style="top: 100px"
        >
            <!-- <div class="absolute-all overflow-auto" :style="{ top: $route.meta.title ? '100px' : '77px' ,}" style="top: 100px;width: 1480px;margin-left: calc((100% - 1480px)/2)"> -->
            <router-view class="absolute-all" style="bottom: 24px" />
            <el-dialog :visible.sync="changePsssFlg" title="修改密码" width="30%" append-to-body>
                <div class="bg-default flex-x-center" style="height: 300px">
                    <el-form ref="form" :model="form" :rules="rules" size="small" label-position="left" label-width="94px" class="formButtonRight mt-24" style="width: 500px">
                        <idc-form-item :form="form" :config="formConfig" col="24" clearable>
                            <!-- <el-button @click="$emit('cancel')">取消</el-button>
                            <el-button type="primary" @click="submit">确定</el-button> -->
                        </idc-form-item>
                    </el-form>
                </div>
                <span slot="footer">
                    <el-button @click="changePsssFlg = false" class="float-right">
                        取 消
                    </el-button>
                    <el-button @click="changePassWord" type="primary" class="float-right">
                        确 定
                    </el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import menu from '../../router/menu';
import router from '../../router';
import messagePop from './infoMess';
import testMain from '../homePage/index';
import Bus from '../../../src/http/Bus';
import requsetURL from '../../../public/defaultRequest.js';
import resetPasswordDialog from '../personCenter/resetPasswordDialog';
// import {store} from '@/store/index';
export default {
    components: { messagePop, testMain, resetPasswordDialog },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // vm.getData()
        });
    },
    data() {
        return {
            // activeIndex: 'institutions',
            // activeIndex: '',
            showMore: false,
            downloadData: [],
            time: '',
            menuData: menu,
            translateX: 0,
            moveNumber: 0,
            otherMenu: [],
            name: '',
            src: '',
            notice: [],
            doThing: [],
            changePsssFlg: false,
            form: {},
            formConfig: [
                { itemType: 'input', prop: 'oldPassword', label: '旧密码：' },
                { itemType: 'input', prop: 'newPassword1', label: '新密码：' },
                { itemType: 'input', prop: 'newPassword2', label: '确认密码：' }
            ],
            rules: {
                oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
                newPassword1: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                newPassword2: [{ required: true, message: '请输入确认密码', trigger: 'blur' }]
            }
            // badgeLength: 1,
        };
    },
    computed: {
        menuStyle() {
            return { transform: `translateX(${this.translateX}px)` };
        },
        breadcrumbData() {
            return [{  title: '首页' }, { title: this.$route.meta.title }];
        },
        badgeLength1() {
            return this.doThing.length + this.notice.length || 0;
        },
        checkPicChange() {
            return this.$store.getters.getChangeUser;
        }
    },
    watch: {
        $route(val) {
            this.activeIndex = val.meta.child ? val.meta.child : val.name;
            this.getData();
            this.init();
        },
        checkPicChange(val, oval) {
            if (val != oval) {
                this.getPic();
            }
        },
        downloadData(nval, oval) {
            let data = this.getcomplement(nval, oval) || [];
            if (nval.length == 0 && oval.length == 0) {
                const that = this;
                clearInterval(that.time);
                clearInterval(this.time);
            }
            if (data.length) {
                data.forEach((item, index) => {
                    const that = this;
                    that.$notify({
                        title: '提示',
                        message: `${item.fileName}可导出`,
                        duration: 5000,
                        type: 'success'
                    });
                    // setTimeout(function(){

                    // },2000)
                });
            }
        }
    },
    created() {
        const arr1 = [{ id: 1 }, { id: 3 }, { id: 3333 }],
            arr2 = [{ id: 2 }, { id: 3 }, { id: 4 }, { id: 45 }];
        // let intersection = arr1.filter(function (val) { return arr2.indexOf(val) > -1 })

        // // 并集
        // let union = arr1.concat(arr2.filter(function (val) { return !(arr1.indexOf(val) > -1) }))

        // 补集 两个数组各自没有的集合
        // let complement = arr1.filter(function (val) { return !(arr2.indexOf(val) > -1) })
        // .concat(arr2.filter(function (val) { return !(arr1.indexOf(val) > -1) }))

        // 差集 数组arr1相对于arr2所没有的
        // let diff = arr1.filter(function (val) { return arr2.indexOf(val) === -1 })
        // let diff = arr1.filter(function (val) { return arr2.map(s=>s.id).indexOf(val) === -1 })
        let diff = arr2.filter(temp => arr1.map(s => s.id).indexOf(temp.id) === -1);
        this.getPic();
        this.getName();

        this.activeIndex = this.$route.meta.child ? this.$route.meta.child : this.$route.name;
        this.getOtherMenu();
        this.getSelfMenu();
        this.getMes();
        this.getWillDoThing();
        this.init();
    },
    beforeDestroy() {
        clearInterval(this.time);
    },
    methods: {
        init() {
            const that = this;
            clearInterval(this.time);
            this.time = setInterval(function () {
                that.getData();
            }, 10000);
        },
        getcomplement(arr1, arr2) {
            if (!arr1 || !arr2) {
                return [];
            }
            return arr2.filter(temp => arr1.map(s => s.id).indexOf(temp.id) === -1);
        },
        getData() {
            //  return false
            let data = {};
            data.pageNum = 1;
            data.pageSize = 9999;
            data.type = '';
            this.$http.get(this.$service.comprehensiveQuery.exportFileManagement.getTableData, { params: data }).then(res => {
                if (res.message === '查询成功' || res.message === 'ok') {
                    this.downloadData = res.data.rows.filter(s => s.status !== 'copy') || [];
                    const that = this;
                    if (this.downloadData.length === 0) {
                        clearInterval(this.time);
                        clearInterval(that.time);
                    }
                } else {
                    clearInterval(this.time);
                }
            });
        },
        getPic() {
            //获取头像
            this.$http.get(this.$service.home.headPortrait, { responseType: 'blob' }).then(res => {
                this.src = URL.createObjectURL(res);
                this.$store.commit('changeUserInfo', false);
            });
        },
        changePassWord() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (this.form.newPassword1 !== this.form.newPassword2) {
                    this.$message({
                        message: '两次输入密码不一致',
                        type: 'warning'
                    });
                    return;
                }
                let params = {
                    oldPassword: this.form.oldPassword,
                    newPassword: this.form.newPassword1
                };
                this.$http.post(this.$service.personCenter.setPassword, params).then(res => {
                    if (res && res.message && res.message.indexOf('成功')) {
                        this.$message({
                            type: 'success',
                            message: res.message
                        });
                        this.changePsssFlg = false;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.message || '修改失败'
                        });
                    }
                    this.$emit('cancel');
                });
            });
        },
        getName() {
            // 获取用户名
            //  this.$http.get(this.$service.home.getName).then(res=>{
            this.$http.get(this.$service.personCenter.getUserInfo).then(res => {
                if (res.data != null) {
                    this.name = res.data.userName;
                } else {
                    this.$message({ type: 'warning', message: '获取用户名失败' });
                }
            });
        },
        changeMenu(val) {
            sessionStorage.setItem('currentPath', val);
            this.activeIndex = val;
            this.$route.name !== val && this.$router.push({ name: val });
        },
        dropDownCommand(val) {
            switch (val) {
            case 'out':
                sessionStorage.clear();
                // this.$http.post(this.$service.main.loginOut, {}).then(res => {});

                setTimeout(function () {
                    window.location.replace(
                        `${requsetURL}/auth/logout?token=${JSON.parse(
                            window.sessionStorage.getItem('token')
                        )}&response_type=code&client_id=gongxiao_basic&redirect_uri=${requsetURL}/api/basic/auth/loginSuccess?state=kk`
                    );
                }, 500);
                break;
            case 'center':
                this.$router.push({ name: 'personCenter' });
                break;
            case 'changePass':
                this.changePsssFlg = true;
                break;
            }
        },
        move(direction) {
            let moveX = this.menuData[this.moveNumber].children ? 116 : 96;
            // if (this.moveNumber >= (this.menuData.length - 7) || this.moveNumber <= (7 - this.menuData.length)) return;
            if (direction === 'left') {
                moveX = this.menuData[this.moveNumber - 1].children ? 116 : 96;
                this.translateX += moveX;
                this.moveNumber--;
            } else {
                this.translateX -= moveX;
                this.moveNumber++;
            }
        },
        getOtherMenu() {
            this.$http.get(this.$service.main.otherMenu).then(res => {
                // 菜单栏的dropdowm
                this.otherMenu = res.data || [];
            });
        },

        getSelfMenu() {
            // 菜单过滤 el-menu
            this.$http.get(this.$service.main.getslefMenu).then(res => {
                sessionStorage.setItem('selfMenu', res.data.menu);
                sessionStorage.setItem('selfButton', res.data.button);
                // if(res.data.menu.includes('export_file')) {
                //     this.init()
                // }
                let tempArr = res.data.menu;
                this.menuData.forEach(item => {
                    if (item.children) {
                        item.children = item.children.filter(s => tempArr.split(',').includes(s.selfFlg));
                    }
                });
                this.menuData = this.menuData.filter(s => tempArr.split(',').includes(s.selfFlg));
            });
        },
        toOtherSystem(val) {
            if (val) window.location.href = val;
        },
        // 获取系统通知和代办事项
        async getMes() {
            await this.$http.get(this.$service.main.queryMessagePage, { pageNum: 1, pageSize: '999' }).then(res => {
                this.notice = res.data.rows.filter(s => s.status === 'VALID');
                // this.notice =  res.data.rows
            });
            // this.notice =  [{test:'1111',time:'2019'},{test:'44444444',time:'2019'}]
            // this.
        },
        async getWillDoThing() {
            await this.$http.get(this.$service.main.queryBacklogPage, { pageNum: 1, pageSize: '999' }).then(res => {
                this.doThing = res.data.rows.filter(s => s.status === 'VALID');
                // this.doThing = res.data.rows
            });
            // this.doThing =  [{test:'3333333333',time:'2019'},{test:'5666',time:'2019'}]
        },
        sonClear1() {
            this.notice = [];
        },
        sonClear2() {
            this.doThing = [];
        }
    }
};
</script>
<style>
.selfIcon {
	color: white;
	position: absolute;
	top: -17px;
	left: -15px;
}
</style>
